import React from 'react'

function Label({ children, ...rest }) {
    return (
        <div className={`text-sm font-medium ${rest.className}`} {...rest}>
            {children}
        </div>
    )
}

export default Label